// extracted by mini-css-extract-plugin
export var bohoLuxe = "styles-module--bohoLuxe--zYJpG";
export var headerContainer = "styles-module--headerContainer--4JoLI";
export var bohoLuxeGallery = "styles-module--bohoLuxeGallery--IFU6C";
export var bohoLuxeRow = "styles-module--bohoLuxeRow--3zIBl";